<template>
  <div class="autopilot-container">
    <TFlex><h1>{{$t('Project.Settings.Autopilots.Label')}}</h1></TFlex>
    <v-list-group
      v-for="(ap, ap_index) in getAutopilots"
      :key="`autopilotproject${ap_index}`"
      :value="ap_show_index === ap_index"
      @input="ap_show_index = ap_index"
      no-action
    >
      <template #prependIcon>
          <!-- <v-list-item-action> -->
          <v-icon v-if="ap.selected_id !== -1" :color="ap.active ? 'green' : 'grey'">check_circle_outline</v-icon>
          <v-icon v-else color="grey">panorama_fish_eye</v-icon>
          <v-btn
            icon
            :disabled="ap.selected_id === -1"
            @click.stop="updateAutopilot({
              project_id: project_id,
              active: !ap.active,
              key: ap_index,
              autopilot_id: ap.selected_id
            })">
            <v-icon v-if="ap.active" color="green">pause_circle_outline</v-icon>
            <v-icon v-else>play_circle_outline</v-icon>
          </v-btn>
        <!-- </v-list-item-action> -->
      </template>
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title v-text="ap.name"></v-list-item-title>
          <v-list-item-subtitle v-text="'description'"></v-list-item-subtitle>
        </v-list-item-content>
      </template>
      <v-list-item
        v-for="fun in ap.functions"
        :key="`apfunctions${fun.id}`"
        style="cursor: pointer;"
        :class="ap.selected_id === fun.id ? ap.active ? 'green' : 'grey' : ''"
        @click="ap.selected_id === fun.id ?
          deleteAutopilot({
            project_id: project_id,
            key: ap_index,
            autopilot_id: fun.id
          }) :
          createAutopilot({
            project_id: project_id,
            autopilot: fun.id,
            key: ap_index
          })"
      >
        <v-list-item-content>
          <v-list-item-title>
            Level {{fun.level}}
          </v-list-item-title>
          <v-list-item-subtitle v-text="fun.description"></v-list-item-subtitle>
        </v-list-item-content>
        <!-- <v-list-item-icon>
          <v-icon v-if="fun.active">pause_circle_outline</v-icon>
          <v-icon v-else>play_circle_outline</v-icon>
        </v-list-item-icon> -->
      </v-list-item>
    </v-list-group>
    <TFlex wrap="wrap">
      <v-card
      v-for="issue in getUObjects({ type: 'autopilotissues' })"
      :key="`issue${issue.id}`"
      class="ma-2"
      :color="issue.parent.color"
      :style="`color: ${issue.parent.textcolor}`"
      max-width="344"
      >
      <div v-if="issue.parent_type === 'twork_package'">
        <WorkPackageHead
          :head="{
            token: issue.parent.token,
            name: issue.parent.name,
            icon: issue.parent.icon,
            area: issue.parent.taktarea_name,
            status_done_count: $store.state.Ultra.status_array.findIndex(status => status.name === issue.parent.status),
            status_is_stop: issue.parent.stop_status,
          }"
          :foreground_color="calc_fg_hex(issue.parent.textcolor)"
          :readonly="true"
          />
        <!-- <v-card-title></v-card-title> -->
        <v-card-subtitle>ISSUE.status: <b>{{ issue.status }}</b></v-card-subtitle>
        <v-card-text>
          {{ issue.logentries[0].value }}
        </v-card-text>
          <v-card-actions>
            <v-btn @click="updateUObject({
              url: [
                { projects: project_id },
                { autopilotissues: issue.id },
              ],
              update: { status: issue.status === 'resolved' ? 'open' : 'resolved' }
              })"
            >
                {{ issue.status === 'resolved' ? 'reopen' : 'resolve' }}
            </v-btn>
            <v-btn @click="routeToParent(issue)">go to work package</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </TFlex>
  </div>
</template>
<script>
// import store from '@/store/index';
import TFlex from '@/components/Taktify/TFlex.component.vue';
// import TWorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
// import TWaggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import WorkPackageHead from '@/modules/WorkPackageWIP/WorkPackageHead.module.vue';

import colors from 'vuetify/lib/util/colors';
import {
  mapGetters, mapActions
} from 'vuex';
export default {
  components: {
    TFlex,
    // TWorkPackage,
    // TWaggon,
     WorkPackageHead
  },
  name: 'ProjectAutopilots',
  props: ['project_id'],
  data: function() {
    return {
      ap_show_index: -1
    }
  },
  created() {
    this.requestAutopilots({ project_id: this.project_id });
    this.requestUObject({
      url: [
        {projects: this.project_id},
        {autopilotissues: ''},
        {showWithEntitiesNormalized: ''}
      ]
    });
  },
  computed: {
    ...mapGetters('Project', [
      'hasProjectPermission'
    ]),
    ...mapGetters('Autopilot', [
      'getAutopilots'
    ]),
    ...mapGetters('Ultra', [
      'getUObjects'
    ])
  },
  methods: {
    ...mapActions('Ultra', [
      'requestUObject',
      'createUObject',
      'updateUObject',
      'deleteUObject'
    ]),
    ...mapActions('Autopilot', [
      'requestAutopilots',
      'createAutopilot',
      'deleteAutopilot',
      'updateAutopilot'
    ]),
    routeToParent(issue){
      // console.log('issue', issue);
      switch (issue.parent_type) {
        case 'twork_package':
          this.$router.push({
            name: 'TaktPlanWorkPackageInfo',
            params: {
              project_id: this.project_id,
              train_id: issue.parent.train_id,
              taktarea_id: issue.parent.taktarea_id,
              twaggon_id: issue.parent.twaggon_id,
              tworkpackage_id: issue.parent.id,
            }
          });
          break;
      }
    },
    translateAutopilotType(type){
      switch (type) {
        case 'wp_status':
        case 'wp_status_ti':
          return 'WORK.package Status';
      }
      return 'error';
    },
    translateAutopilotFunction(type){
      switch (type) {
        case 'WorkPackageStatus':
          return 'WORK.package status';
        case 'WorkPackageManpower':
          return 'WORK.package manpower';
      }
      return 'error';
    },
    translateAutopilots(type){
      switch (type) {
        case 'workpackage_WorkPackageManpower':
          return 'WORK.package manpower';
        case 'workpackage_WorkPackageStatus':
        return 'WORK.package status';
      }
      return 'error';
    },
    translateParentType(type){
      switch (type) {
        case 'twork_package':
          return 'WORK.package'
      }
      return 'error';
    },
    calc_fg_hex(color) {
      let textcolor = color;
      if (textcolor.includes('black')) {
        return '#000'
      } else if (textcolor.includes('white')) {
        return '#FFF'
      } else {
        return colors[textcolor];
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.autopilot-container {
  width: 90%;
  margin-left: 5%;
}
.autopilot-item {
  padding: 5px;
  // border-radius: 5px;
}
.ap-function-card-active,
.ap-function-card:hover {
  background-color: grey;
}
.ap-function-card {
  height: 200px;
  width: 250px;
  padding: 5px;
  margin: 2px;
  border-radius: 5px;
  border: 1px solid grey;
}
</style>
